import { combineReducers } from "@reduxjs/toolkit";

//Project imports
import AuthenticationData from "./authReducer";
import { BlockReducer } from "./blockReducer";
export default combineReducers({
    AuthenticationData,
    BlockReducer
  });